import type { GaApp } from '~/modules/app'

export class PageService {
  gaApp: GaApp

  constructor(gaApp: GaApp) {
    this.gaApp = gaApp
  }

  async getData(redirect: Record<string, string>) {
    switch (redirect.pageType) {
      case 'rating':
        // Не ждём API — страница рендерится сразу, лоадер на UI
        void this.gaApp.services.main.rating.loadCurrentLeaderboard()
        return
      case 'menu':
        void this.gaApp.services.main.menu.loadProfile()
        return
      default:
        return
    }
  }

  redirectError(error: any) {
    // eslint-disable-next-line ts/no-unsafe-member-access
    if (error.statusCode >= 500) {
      // eslint-disable-next-line ts/no-unsafe-argument
      return this.gaApp.redirectError({ ...error, statusCode: 500 })
    }

    // eslint-disable-next-line ts/no-unsafe-argument
    return this.gaApp.redirectError({ ...error, statusCode: 404 })
  }
}
